import React, { useState } from 'react';
import BetInput from '../betInput';
import AdditionalButtons from '../additionalButtons';
import BetButton from '../betButton';

const BetSectionFooter = ({
  t,
  onBlur,
  limits,
  balance,
  onChange,
  betAmount,
  isDisabled,
  autoBetData,
  activeFreeBet,
  changeBetAmount,
  handleOpenNumPad,
  showNotification,
  handleChangeInputValue,
}) => {
  const [isValidatedAmount, setIsValidatedAmount] = useState(false);
  const { isAutoBet, autoBetCount } = autoBetData;

  const decidedCallBackCall = (callback) => {
    if (isValidatedAmount) {
      setIsValidatedAmount(false);
    } else {
      return callback();
    }
    return null;
  };

  return (
    <div className='b-s-btn-wrp'>
      <div
        className={`b-s-btn-left ${
          !activeFreeBet?.id && (!isAutoBet || (isAutoBet && !autoBetCount)) ? '' : 'passive'
        }`}
      >
        <BetInput
          onBlur={onBlur}
          limits={limits}
          onChange={onChange}
          betAmount={betAmount}
          isDisabled={isDisabled}
          changeBetAmount={changeBetAmount}
          handleOpenNumPad={handleOpenNumPad}
          decidedCallBackCall={decidedCallBackCall}
          setIsValidatedAmount={setIsValidatedAmount}
          showNotification={showNotification}
          handleChangeInputValue={handleChangeInputValue}
        />
        <AdditionalButtons
          t={t}
          limits={limits}
          balance={balance}
          betAmount={betAmount}
          changeBetAmount={changeBetAmount}
          decidedCallBackCall={decidedCallBackCall}
          handleChangeInputValue={handleChangeInputValue}
        />
      </div>
      <BetButton decidedCallBackCall={decidedCallBackCall} />
    </div>
  );
};

export default BetSectionFooter;
